const content = `
# Admin Shares & Audit (Phase 4)

The **/shares** page is the global view across every demo invitation issued from this Eyvo Demo Agent instance.

## What you can do

- **Filter** invitations by status, the operator who issued them, recipient email
  (contains search), or recipient domain (\`@acme.com\`).
- **Select** one or many invitations with the row checkboxes and run a
  **bulk revoke** or **bulk resend** from the action bar that appears at the
  top of the table. Bulk actions return a per-invitation result so you can
  see exactly which ones succeeded.
- **Drill in** by clicking the recipient email to open
  \`/shares/<invitation_id>\` — the per-invitation page shows:
  - Status, expiry, view count, max playback position, estimated watch time.
  - Delivery info (SendGrid send count, current message ID, send failures).
  - A timeline of every audit event (sent / opened / playback / heartbeats /
    revoke attempts) with IP, session id, and playback position where applicable.
  - A heartbeat density chart bucketed in 30 s windows — useful for spotting
    skim watchers vs. attentive ones.

## Resend rate limits

Each invitation can be re-sent at most **3 times per 24 hours**. Bulk resend
respects this cap per-row — items that would exceed the cap come back with
status \`rate_limited\` and the rest of the batch still goes through.

## Viewer activity feed

The teal "Viewer activity" tile at the top of \`/shares\` (and on the **Demo Runs** list)
shows the most recent viewer events across the system: opens, playback starts,
completions, and attempts on expired or revoked links. Click any row to jump
to the per-invitation drill-down.

## Permissions

| Role | Sees |
|------|------|
| \`admin\`, \`builder\` | Every invitation across every run |
| \`presenter\` | Only invitations they issued themselves |
| \`viewer\` | Nothing — the nav entry is hidden |

## Where the data comes from

- **Invitations** live in \`video_invitations\` (one row per email).
- **Audit events** live in \`video_view_audit\` (append-only, one row per event).
- **Run/workflow metadata** is joined in from \`demo_runs\` + \`workflows\`
  so the table can show run number and workflow name without an extra hop.

If the table is empty after sending invitations, double-check that the SendGrid
API key and sender DNS are configured — failed sends show up in the per-invitation
delivery panel as \`send_failures\`.
`;

export default content;
